import * as React from 'react';
import { ButtonModifier } from '../../../infrastructure/helpers';
import DefaultButton, { ButtonProp } from '../default-button/default-button';
import { createClosePopoverButton } from './create-close-popover-button';

const DefaultClosePopoverButtonPresentation = (props: Partial<ButtonProp>) => {
    const propsWithDefaults = {
        modifier: ['cancel', 'fat'] as ButtonModifier[],
        text: 'Cancel',
        ...props,
    };

    return <DefaultButton {...propsWithDefaults} />;
};

const DefaultClosePopoverButton = createClosePopoverButton<Partial<ButtonProp>>(DefaultClosePopoverButtonPresentation);

export { DefaultClosePopoverButton };